import { type ReactNode } from 'react'
import { IconButton } from '@/components/IconButton'
import { SearchField } from '@/components/SearchField'
import { UnreadBadge } from '@/components/UnreadBadge'
import styles from './PrimaryControls.module.css'
import { Tooltip } from '@/components/Tooltip'

export interface PrimaryControlsProps {
  renderMenu: (button: ReactNode) => ReactNode
  filterCount: number
  value: string
  onChange: (val: string) => void
  onShowFilterControls: () => void
}

export function PrimaryControls({
  renderMenu,
  filterCount,
  value,
  onChange,
  onShowFilterControls,
}: PrimaryControlsProps) {
  const hasFilter = filterCount > 0
  const filterTooltip = hasFilter
    ? `${filterCount} ${filterCount > 1 ? 'filters' : 'filter'} selected`
    : 'Filter'
  const menuTooltip = 'Menu'

  return (
    <div className={styles.primaryControls}>
      <div className={styles.search}>
        <SearchField
          embedded
          appearance="toolbar"
          stretch
          value={value}
          onChange={onChange}
          testId="job-search-field"
        />
      </div>
      <div className={styles.actions}>
        <div className={styles.actionButton}>
          <Tooltip content={filterTooltip} placement="bottom">
            <IconButton
              name="filter"
              label="Filters"
              onPress={onShowFilterControls}
              testId="job-filter-controls-toggle"
              color="var(--grey600)"
            />
          </Tooltip>
          {filterCount > 0 && (
            <UnreadBadge className={styles.filterCount} count={filterCount} />
          )}
        </div>
        <div className={styles.actionButton}>
          {renderMenu(
            <Tooltip content={menuTooltip} placement="bottom">
              <IconButton
                name="more"
                label="More actions"
                testId="job-management-table-menu-toggle"
                color="var(--grey600)"
              />
            </Tooltip>,
          )}
        </div>
      </div>
    </div>
  )
}
